/**
 * InlineCitedText — renders a payload string, turning each `[3]` / `[3,7,12]`
 * marker into one clickable chip PER NUMBER.
 *
 * The grammar lives in `../citationMarkers`; a marker whose numbers resolve to
 * no citation is left as literal text so nothing silently disappears from the
 * answer.
 */

import React from 'react';
import { ResearchCitation } from '../types';
import { parseMarkers } from '../citationMarkers';
import { CitationChip, CitationHandlers, findCitation } from './CitationChip';

interface Props extends CitationHandlers {
  text: string;
  citations: ResearchCitation[];
}

const InlineCitedText: React.FC<Props> = ({ text, citations, ...handlers }) => {
  if (!text) return null;

  const known = (n: number) => !!findCitation(citations, n);
  const nodes: React.ReactNode[] = [];

  parseMarkers(text, known).forEach((segment, i) => {
    if (segment.kind === 'text') {
      nodes.push(segment.text);
      return;
    }
    segment.numbers.forEach((number) => {
      const citation = findCitation(citations, number);
      if (citation) {
        nodes.push(<CitationChip key={`${i}-${number}`} citation={citation} {...handlers} />);
      }
    });
  });

  return <>{nodes}</>;
};

export default InlineCitedText;
